module.exports = __webpack_public_path__ + "img/copywriting3.9e712542.jpg";